export default "__VITE_ASSET__DWvgjnN___"